<style>
  .ivu-table .demo-table-info-row td{
    background-color: #2db7f5;
    color: #fff;
  }
  .ivu-table .demo-table-error-row td{
    background-color: #f6caca;
  }
</style>
<template>
  <div>
    <Row>
      <Col :span="tableCol">
        <Table
          :row-class-name="rowClassName"
          border
          highlight-row
          ref="table"
          :loading="tableLoading"
          :data="table.data"
          :columns="table.columns">
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
          </div>
          <div style="float: right;">
            <page
              :total="table.count"
              :current="table.page"
              :page-size="table.size"
              @on-change="getTableData"></page>
          </div>
        </div>
      </Col>
      <Col :span="detailCol">
        <detail ref="detailRef" @on-result-change="onResultChange"></detail>
      </Col>
    </Row>
  </div>
</template>

<script>
import { GetWorkSheet } from '@/api/logistics/worksheet'
import detail from './detail'
import eventVue from './event.js'

export default {
  name: 'workSheetTable',
  components: {
    detail
  },
  props: ['tableColumns', 'status'],
  data () {
    return {
      statusOwn: this.status,
      tableLoading: false,
      table: {
        data: [],
        columns: this.tableColumns,
        count: 0,
        size: 10,
        page: 1
      },
      tableCol: '24',
      detailCol: '8',
      searchForm: {},
      screenWidth: document.body.clientWidth
    }
  },
  watch: {
    status (value) {
      this.statusOwn = value
      // this.init()
    }
  },
  created: function () {
    console.log('created')
    this.init()
    this.searchFun()
    eventVue.$on('enlargeFun', () => {
      this.enlarge()
    })
    eventVue.$on('narrowFun', () => {
      this.narrow()
    })
    eventVue.$on('closeFun', () => {
      this.close()
    })
  },
  methods: {
    rowClassName (row, index) {
      // console.log(row.deadline)
      if (row.deadline && row.status === 2) {
        let deadline = new Date(row.deadline)
        let current = new Date()
        if (deadline.getTime() < current.getTime()) {
          return 'demo-table-error-row'
        }
      }
      return ''
    },
    onResultChange () {
      this.init()
    },
    init () {
      this.getTableData()
    },
    getTableData (value = 1, searchForm = this.searchForm) {
      this.tableLoading = true
      this.searchForm = searchForm
      this.table.page = value
      let params = {
        'size': this.table.size,
        'page': this.table.page,
        'status__in': this.statusOwn.join(','),
        'wsid': searchForm.wsid,
        'type': searchForm.type,
        'submitter': searchForm.submitter,
        'title': searchForm.title,
        'operator__name': searchForm.operator,
        'search_all': searchForm.search_all
      }
      GetWorkSheet(params).then(res => {
        this.table.data = res.data.results
        this.table.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
      })
    },
    searchFun () {
      eventVue.$on('myFun', (searchForm) => {
        this.searchForm = searchForm
        this.getTableData(1, searchForm)
      })
    },
    detail (id) {
      this.tableCol = '13'
      this.detailCol = '11'
      if (this.screenWidth < 768) {
        this.tableCol = '0'
        this.detailCol = '24'
      }
      this.$refs.detailRef.init(id)
    },
    enlarge () {
      this.tableCol = '0'
      this.detailCol = '24'
    },
    narrow () {
      this.tableCol = '13'
      this.detailCol = '11'
      if (this.screenWidth < 768) {
        this.tableCol = '10'
        this.detailCol = '14'
      }
    },
    close () {
      this.tableCol = '24'
      this.detailCol = '0'
    }
  }
}
</script>

<style scoped>

</style>
